import { ComponentAPI } from '@philips-emr/tws-core';

class ImageAPI extends ComponentAPI {

  getSrc(): string {
    return this.state.src;
  }

  setSrc(src: string): void {
    this.setState({ src });
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }

  isLoading(): boolean {
    return this.state.loading;
  }

  setLoading(loading: boolean): void {
    this.setState({ loading });
  }

  getWidth(): string {
    return this.state.width;
  }

  setWidth(width: string): void {
    this.setState({ width });
  }

  getHeight(): string {
    return this.state.height;
  }

  setHeight(height: string): void {
    this.setState({ height });
  }

  getAlt(): string {
    return this.state.alt;
  }

  setAlt(alt: string): void {
    this.setState({ alt });
  }

  getMinWidth(): string {
    return this.state.minWidth;
  }

  setMinWidth(minWidth: string): void {
    this.setState({ minWidth });
  }

  getMaxWidth(): string {
    return this.state.maxWidth;
  }

  setMaxWidth(maxWidth: string): void {
    this.setState({ maxWidth });
  }
  
  getMinHeight(): string {
    return this.state.minHeight;
  }

  setMinHeight(minHeight: string): void {
    this.setState({ minHeight });
  }

  getMaxHeight(): string {
    return this.state.maxHeight;
  }

  setMaxHeight(maxHeight: string): void {
    this.setState({ maxHeight });
  }

}

export default ImageAPI;
